import { useCallback } from "react";
import { Column, Link, Row } from "@react-email/components";
import { defaultStyles } from "../defaultStyles";

interface CommunityUrlSectionProps {
  isPreviewMode: boolean;
  rootUrl: string;
  styles?: Record<string, string | number>;
}

export const CommunityUrlSection = ({
  rootUrl,
  isPreviewMode,
  styles = {},
}: CommunityUrlSectionProps) => {
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (isPreviewMode) event.preventDefault();
    },
    [isPreviewMode],
  );

  if (!rootUrl) {
    return null;
  }

  return (
    <Row style={styles}>
      <Column align="center">
        <Link
          style={defaultStyles.content.link}
          href={rootUrl}
          onClick={handleClick}
        >
          {rootUrl}
        </Link>
      </Column>
    </Row>
  );
};
